export enum TimelineScrollSource {
  DefaultMode = 'none',
  ZoomMode = 'zoom',
  ScrollBySelection = 'scrollBySelection',
}
